import { StyledReactSelect } from '@fountain/fountain-ui-components';
import { Grid } from '@material-ui/core';
import { produce } from 'immer';
import React, { FC, useContext } from 'react';
import { useIntl } from 'react-intl';

import { getConditionErrorMessage } from 'containers/WorkflowEditor/components/Rules/Condition/constants';
import { RulesEditDataContext } from 'containers/WorkflowEditor/contexts/rulesEditDataContext';
import globalMessages from 'shared/global/messages';

import { DocumentSigningRuleProps } from '../../DocumentSigningRules/types';
import { RulesProps, SharedConditionProps } from '../../types';
import { messages } from './messages';

export const ComplianceStatus: FC<SharedConditionProps> = ({
  condition,
  ruleId,
  setRules,
  setDocumentSigningRules,
  errors,
}) => {
  const intl = useIntl();

  const { extra } = condition;

  const { condition_statuses: conditionStatuses } =
    useContext(RulesEditDataContext);

  const statusLabelMap: Record<string, string> = {
    IN: intl.formatMessage(messages.inCompliance),
    OUT: intl.formatMessage(messages.outOfCompliance),
    PENDING_REVIEW: intl.formatMessage(messages.pendingReview),
  };

  const statusOptions = conditionStatuses?.compliance?.map(status => ({
    label: statusLabelMap[status] ?? status,
    value: status,
  }));

  const selectedStatus =
    statusOptions?.find(option => option.value === extra.status) ?? null;

  const onChangeStatus = (newStatus: { label: string; value: string }) => {
    const rulesSetter = setRules ?? setDocumentSigningRules;

    if (rulesSetter) {
      rulesSetter(
        produce((draftRules: RulesProps | DocumentSigningRuleProps) => {
          const draftConditions =
            draftRules[ruleId]?.condition_set_attributes
              ?.conditions_attributes ?? [];
          const idx = draftConditions.findIndex(
            cond => cond.id === condition.id,
          );

          if (idx !== -1) {
            draftConditions[idx].extra.status = newStatus.value;
          }
        }),
      );
    }
  };

  const statusErrorMessage =
    !extra?.status && getConditionErrorMessage('status', errors);

  return (
    <Grid item xs={6}>
      <StyledReactSelect
        options={statusOptions}
        label={intl.formatMessage(globalMessages.status)}
        aria-label={intl.formatMessage(globalMessages.status)}
        onChange={onChangeStatus}
        value={selectedStatus}
        error={statusErrorMessage}
        placeholder=""
        required
      />
    </Grid>
  );
};
